import { Controller } from "@hotwired/stimulus"

// Menu controller for keyboard navigation
// Based on Rails Blocks menu pattern
export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.currentIndex = -1
    
    // Bind methods
    this.handleKeydown = this.handleKeydown.bind(this)
    this.element.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.handleKeydown)
  }

  handleKeydown(event) {
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault()
        this.focusNext()
        break
      case "ArrowUp":
        event.preventDefault()
        this.focusPrevious()
        break
      case "Home":
        event.preventDefault()
        this.focusFirst()
        break
      case "End":
        event.preventDefault()
        this.focusLast()
        break
      case "Enter":
      case " ":
        // Let the focused item handle this naturally
        break
      default:
        // Type-ahead search
        if (event.key.length === 1 && !event.metaKey && !event.ctrlKey) {
          this.typeAhead(event.key)
        }
    }
  }

  focusNext() {
    const items = this.itemTargets.filter(item => !item.disabled && !item.hidden)
    if (items.length === 0) return
    
    this.currentIndex = (this.currentIndex + 1) % items.length
    items[this.currentIndex].focus()
  }

  focusPrevious() {
    const items = this.itemTargets.filter(item => !item.disabled && !item.hidden)
    if (items.length === 0) return
    
    this.currentIndex = this.currentIndex <= 0 ? items.length - 1 : this.currentIndex - 1
    items[this.currentIndex].focus()
  }

  focusFirst() {
    const items = this.itemTargets.filter(item => !item.disabled && !item.hidden)
    if (items.length === 0) return
    
    this.currentIndex = 0
    items[0].focus()
  }

  focusLast() {
    const items = this.itemTargets.filter(item => !item.disabled && !item.hidden)
    if (items.length === 0) return
    
    this.currentIndex = items.length - 1
    items[this.currentIndex].focus()
  }

  typeAhead(char) {
    const items = this.itemTargets.filter(item => !item.disabled && !item.hidden)
    if (items.length === 0) return
    
    // Find next item starting with the typed character
    const startIndex = this.currentIndex + 1
    const searchChar = char.toLowerCase()
    
    for (let i = 0; i < items.length; i++) {
      const index = (startIndex + i) % items.length
      const item = items[index]
      const text = item.textContent.trim().toLowerCase()
      
      if (text.startsWith(searchChar)) {
        this.currentIndex = index
        item.focus()
        return
      }
    }
  }

  // Reset focus index when menu opens
  reset() {
    this.currentIndex = -1
  }
}

